import { Transform } from 'class-transformer';
import { IsString, IsNotEmpty, IsMimeType, IsIn, IsOptional } from 'class-validator';
import sanitize from 'sanitize-filename';
import { FileDestinationEnum, FileDestinationArray } from '../../enums';

export type UploadSignedUrl = string;

export interface FileIdWithUrl {
	fileId: string;
	url: UploadSignedUrl;
}

export class CreateFileDto {
	@Transform(({ value }) => (typeof value === 'string' ? sanitize(value) : null))
	@IsNotEmpty()
	@IsString()
	name: string;

	@IsMimeType() mimeType: string;

	@IsIn(FileDestinationArray) destination: FileDestinationEnum;

	@IsOptional()
	createdByUserId?: string;
}
